export default __webpack_public_path__ + "static/media/printnapply 1024.9100a248.svg";